import axios from 'axios'

const Http = axios.create({
  baseURL: process.env.REACT_APP_API_ENDPOINT,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Credentials': 'true',
    'Access-Control-Allow-Methods': 'DELETE, POST, GET, PUT, OPTIONS',
    'Access-Control-Allow-Headers':
      'Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With'
  }
})

Http.interceptors.request.use(
  function (config) {
    config.headers.Authorization = localStorage.getItem('user-token')
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

Http.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    return Promise.reject(error)
  }
)

export default Http



// WEBPACK FOOTER //
// ./src/api/Http.js